<template>
    <div class="pd20">
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover" class="mgb20">
                    <div>
                        <div class="flex-center mgb20">
                            <p class="hr_tag"></p>
                            <span>筛选</span>
                        </div>
                        <div>
                            <el-form label-width="80px">
                                <el-form-item label="实验时间" class="userRadio">
                                    <el-radio-group v-model="form.month" @change="getData">
                                        <el-radio v-for="(item,index) in dateList" :key="index" :label="item.id" border>{{item.name}}</el-radio>
                                    </el-radio-group>
                                    <el-date-picker v-model="date" align="right" unlink-panels type="daterange"
                                        start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable></el-date-picker>
                                </el-form-item>
                                <div class="flex-between no-mb">
                                    <el-form-item label="实验状态">
                                        <el-select v-model="form.status" clearable placeholder="请选择实验状态" @change="getData">
                                            <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-input placeholder="请输入竞赛群组/项目名称" prefix-icon="el-icon-search" v-model="keyword" clearable @keyup.enter.native="onSearch"></el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>  
                </el-card>
            </el-col> 

            <el-col :span="24">
                <el-card shadow="hover" class="mgb20">
                    <div class="flex-between mgb20">
                        <div class="flex-center">
                            <p class="hr_tag"></p>
                            <span>竞赛管理</span>
                        </div>
                    </div>
                    <el-table :data="customerData" class="table" stripe header-align="center" :row-key="getRowKeys">
                        <el-table-column type="index" width="100" label="序号" align="center">
                            <template slot-scope="scope">
                                {{scope.$index + (pageNo - 1) * pageSize + 1}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="experimentalName" label="竞赛名称" align="center"></el-table-column>
                        <el-table-column prop="experimentalClassName" label="竞赛群组" align="center">
                        </el-table-column>
                        <el-table-column prop="experimentalNumber" label="参赛人数" align="center"></el-table-column>
                        <el-table-column prop="experimentDuration" label="考核时长" align="center">
                        </el-table-column>
                        <el-table-column prop="creationTime" label="创建时间" align="center">
                        </el-table-column>
                        <el-table-column prop="startTime" label="起始时间" align="center">
                        </el-table-column>
                        <el-table-column prop="stopTime" label="结束时间" align="center">
                        </el-table-column>
                        <el-table-column label="倒计时" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.surplusTime == '838:00:00'">>30天</span>
                                <span v-else-if="scope.row.status == 2">{{scope.row.surplusTime}}</span>
                                <span v-else>00:00:00</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实验状态" align="center">
                            <template slot-scope="scope">
                                <span class="ellipsis">{{status[scope.row.status]}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <!-- <el-button v-if="scope.row.status != 3" type="text" @click="entry(scope.row)" :disabled="scope.row.status != 2">进入</el-button>
                                <el-button v-else type="text" @click="show(scope.row)">查看成绩</el-button> -->
                                
                                <el-button v-if="scope.row.status == 3 && !scope.row.reportId" type="text" disabled>未参加</el-button>
                                <el-button v-if="scope.row.status != 3 && !scope.row.reportId" type="text" @click="entry(scope.row)" :disabled="scope.row.status != 2">进入</el-button>
                                <el-button v-if="scope.row.status == 2 && scope.row.reportId" type="text" disabled>已提交</el-button>
                                <el-button v-if="scope.row.status == 3 && scope.row.reportId" type="text" @click="show(scope.row)">查看成绩</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination background layout="total, prev, pager, next" :total="totals" @current-change="handleCurrentChange" :current-page="pageNo">
                        </el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog title="请输入邀请码" :visible.sync="icVisible" width="30%" @close="closeIc" center :close-on-click-modal="false">
            <el-input v-model="invitationCode" placeholder="邀请码" maxlength="6"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveIc">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'project',
    data() {
        return {
            pattern: Number(this.$store.state.pattern),
            userId: this.$store.state.userId,
            schoolId: this.$store.state.schoolId,
            name: sessionStorage.getItem('ms_username'),
            status: ['','待开始','进行中','已完成'],
            statusList: [{
                name:'不限',
                value: 0
            },{
                name:'待开始',
                value: 1
            },{
                name:'进行中',
                value: 2
            },{
                name:'已完成',
                value: 3
            }],
            customerData: [],
            date: [],
            form: {
                month:'',
                startTime: '',
                endTime: '',
                status: 0,
            },
            keyword: '',
            dateList: [
                {
                    id: '',
                    name: '不限'
                },
                {
                    id: 1,
                    name: '近一个月'
                },
                {
                    id: 3,
                    name: '近三个月'
                },
                {
                    id: 6,
                    name: '近六个月'
                }
            ],
            pageNo: 1,
            pageSize: 10,
            totals: 0,
            icVisible: false,
            invitationCode: '',
            searchTimer: null,
            timer: null,
            curClassName: '',
        };
    },
    watch: {
        'form.month': function(val){
            if(val){
                let unit = 24 * 60 * 60 * 1000
                this.date = [this.core.formatDate('yyyy-MM-dd',new Date(new Date().getTime() - unit * 30 * val)),this.core.formatDate('yyyy-MM-dd',new Date(new Date().getTime() + unit))]
            }else{
                this.date = []
            }
        },
        date: function(val){
            if(val){
                this.form.startTime = val[0]
                this.form.endTime = val[1]
            }else{
                this.form.startTime = ''
                this.form.endTime = ''
            }
            this.getData()
        },
        keyword: function(val) {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.getData()
            },500)
        }
    },
    computed: {
        role() {
            return this.name === 'admin' ? '超级管理员' : '普通用户';
        }
    },
    mounted() {
        this.getData()
        this.timer = setInterval(this.getData,1000)
        this.$once('hook:beforeDestroy',() => {
            clearInterval(this.timer)
        })
    },
    methods: {
        getData() {
            let data = {
                schoolId: this.schoolId,
                month: this.form.month,
                startTime: this.form.startTime,
                endTime: this.form.endTime,
                condition: this.core.encodeString(this.keyword),
                status: this.form.status,
                page: this.pageNo,
                size: this.pageSize,
                rowId: '',
                projectId: '',
                pattern: this.pattern
            }
            
            this.$get(this.api.userRecord,data).then(res => {
                let list = res.page.list
                this.totals = res.page.totalCount
                this.$post(this.api.fictitiousRecord, { 
                    userId: this.userId,
                    page: 1,
                    size: 1000,
                    source: 1,
                    systemId: 3
                }).then(res => {
                    let recordList = res.data.list
                    list.map(n => {
                        let same = recordList.find(e => e.experimentalName == n.experimentalName)
                        if(same){
                            n.reportId = same.reportId
                        }
                    })
                    this.customerData = list
                }).catch(err => {})
            }).catch(res => {});
        },
        add(){
            this.$store.commit("customerData", { customer_id : ''});
            this.$router.push('/addclass');
        },
        edit(row){
            this.$store.commit("customerData", { customer_id : row.customerId });
            this.$router.push('/addcustomer');
        },
        getRowKeys(row) {
            return row.customerId;
        },
        onSearch(){
            this.pageNo = 1
            this.getData()
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getData();
        },
        entry(row) {
            if(row.status == 1){
                return this.$message.warning('该实验尚未开始')
            }else if(row.status == 3){
                return this.$message.warning('该实验已经结束')
            }else{
                this.curClassName = row.experimentalClassName
                this.rowId = row.id
                this.projectId = row.projectId
                if(row.isCode == 1){
                    this.core.toSubSystem(this.curClassName,this.rowId)
                }else{
                    this.$get(this.api.checkInvitationCode,{
                        userId: this.userId,
                        id: row.id
                    }).then(res => {
                        if(res.errmessage == 'false'){
                            this.icVisible = true
                        }else{
                            this.core.toSubSystem(this.curClassName,this.rowId)
                        }
                    }).catch(res => {});
                }
            }
        },
        show(row) {
            this.$router.push(`/showExperiment?id=${row.reportId}`)
        },
        saveIc() {
            if(!this.invitationCode) return this.$message.warning('请输入邀请码')
            if(!this.invitationCode || String(this.invitationCode).length < 6 || isNaN(this.invitationCode)) return this.$message.warning('请输入6位纯数字邀请码')
            let data = {
                id: this.rowId,
                userId: this.userId,
                invitationCode: Number(this.invitationCode)
            }
            this.$post(this.api.joinPractice,data).then(res => {
                if(res.errmessage == 'success') {
                    this.$message.success('验证成功！');
                    this.icVisible = false
                    setTimeout(() => {
                        this.core.toSubSystem(this.curClassName,this.rowId)
                    },1000)
                }
            }).catch(res => {});
        },
        closeIc() {
            this.invitationCode = ''
        },
        goback() {
            this.$router.back()
        },
    }
};
</script>

<style scoped>
.mag{
    margin-right: 20px;
}
/deep/.el-tabs__nav-wrap::after{
    display: none;
}
.no-mb /deep/.el-form-item{
    margin-bottom: 0;
}
</style>

